<template>
    <div>
        <div class="vx-row">
            <div class="vx-col xl:w-1/3 w-full mb-6">
                <vx-card :title="provider.name" id="dataDiv"  class="vs-con-loading__container">
                    <div v-if="editingDisabled">
                        <table class="simple-table">
                            <tr>
                                <td class="font-semibold">Max connections:</td>
                                <td>{{ provider.max_connections }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Allowed connections:</td>
                                <td>{{ provider.allowed_connections }}</td>
                            </tr>
                        </table>
                        <p class="font-semibold">Playlist URL</p>
                        <p>{{ provider.playlist_url }}</p>
                    </div>
                    <div v-else>
                        <p class="mt-6">Name</p>
                        <vs-input v-model="editObject['name']" class="w-full"></vs-input>
                        <p class="mt-6">Max connections</p>
                        <vs-input v-model="editObject['max_connections']" class="w-full"></vs-input>
                        <p class="mt-6">Allowed connections</p>
                        <vs-input v-model="editObject['allowed_connections']" class="w-full"></vs-input>
                        <p class="mt-6">Playlist URL</p>
                        <vs-input v-model="editObject['playlist_url']" class="w-full"></vs-input>
                    </div>
                    <vs-divider/>
                    <vs-button v-if="editingDisabled" style="float: left" color="warning" icon-pack="feather" icon="icon-edit" class="mb-3 mr-3" @click="editingDisabled = false"></vs-button>
                    <vs-button v-if="!editingDisabled" style="float: left" color="success" icon-pack="feather" icon="icon-save" class="mb-3 mr-3" @click="saveProvider">Save</vs-button>
                    <vs-button v-if="!editingDisabled" style="float: right" color="danger" icon-pack="feather" icon="icon-trash-2" class="mb-3 mr-3" @click="removeProvider">Remove</vs-button>
                </vx-card>
            </div>
            <div class="vx-col xl:w-2/3 w-full mb-6">
                <vx-card title="Connections" id="connectionsCard" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[connectionsRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="connectionsRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="connectionsRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="connectionsRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="connectionsRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="connectionsRange = 167">Last 7 days</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="loadConnectionsData()"></feather-icon>
                    </template>

                    <vue-apex-charts v-if="connectionsChartOptions" type="line" height="350" :options="connectionsChartOptions" :series="connectionsData"/>

                </vx-card>
            </div>
        </div>
        <div class="vx-row">

            <div class="vx-col lg:w-1/2 w-full mb-6">
                <vx-card title="Channels" id="channelCard" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[channelRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="channelRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="channelRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="channelRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="channelRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="channelRange = 167">Last 7 days</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="loadChannelData()"></feather-icon>
                    </template>

                    <vue-apex-charts v-if="channelChartOptions" type="line" height="350" :options="channelChartOptions" :series="channelData"/>

                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mb-6">
                <vx-card title="Sources" id="sourceCard" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[sourceRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="sourceRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="sourceRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="sourceRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="sourceRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="sourceRange = 167">Last 7 days</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="loadSourceData()"></feather-icon>
                    </template>

                    <vue-apex-charts v-if="sourceChartOptions" type="line" height="350" :options="sourceChartOptions" :series="sourceData"/>

                </vx-card>
            </div>

        </div>
        <vs-divider/>

        <h4 class="mb-6">IPTV Sources</h4>
        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addSourcePrompt = true">Add</vs-button>
        <sources-table ref="sourcesTable" :sources-u-r-l="'/api/management/v1/provider/' + this.$route.params.id + '/source'" :marked-sources="sourcesInUse"/>

        <vs-popup title="Add source" :active.sync="addSourcePrompt">
            <div id="addSourceDiv" class="vs-con-loading__container" >
                <vs-checkbox class="mt-3" v-model="addObject['checker_enabled']">Enable checker</vs-checkbox>
                <p class="mt-6">URL</p>
                <vs-input v-model="addObject['url']" class="w-full"></vs-input>
                <p class="mt-6">Channel</p>
                <vs-select autocomplete class="w-full" v-model="addObject['channel_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in channels" />
                </vs-select>
                <p class="mt-6">Allowed location</p>
                <vs-select autocomplete class="w-full" v-model="addObject['location_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in locations" />
                </vs-select>
                <p class="mt-6">Input template</p>
                <vs-select autocomplete class="w-full" v-model="addObject['in_template']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in inputTemplates" />
                </vs-select>
                <div v-if="templateMap[addObject['in_template']] && templateMap[addObject['in_template']].params.length > 0">
                    <h6 class="mt-6">Template parameters</h6>
                    <div class="w-full vx-row mb-4" :key="item.key" v-for="item in templateMap[addObject['in_template']].params">
                        <div class="vx-col w-1/2">
                            <vs-checkbox class="mt-3" v-model="enabledParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                        </div>
                        <div class="vx-col w-1/2">
                            <vs-input v-if="enabledParameters.includes(item.key)" v-model="parameterValues[item.key]" class="w-full"></vs-input>
                            <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                        </div>

                    </div>
                </div>

                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addSource">Add</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    import SourcesTable from '../Sources/SourcesTable'
    import VueApexCharts from 'vue-apexcharts'
    export default {
        components: {
            SourcesTable,
            VueApexCharts
        },
        data() {
            return {

                provider: {
                    name: '',
                    max_connections: 0,
                    allowed_connections: 0,
                    playlist_url: ''
                },

                editingDisabled: true,
                editObject: {},

                addSourcePrompt: false,
                inputTemplates: [],
                channels: [],

                addObject: {
                    location_id: 0
                },
                enabledParameters: [],
                parameterValues: {},
                dataLoaded: false,

                channelData: [],
                channelRange: 24,
                channelChartOptions: null,

                sourceData: [],
                sourceRange: 24,
                sourceChartOptions: null,

                connectionsData: [],
                connectionsRange: 24,
                connectionsChartOptions: null,

                locations: [],

                sourcesInUse: [],

                metricTimes: {
                    1: 'Last hour',
                    6: 'Last 6 hours',
                    12: 'Last 12 hours',
                    24: 'Last 24 hours',
                    167: 'Last 7 days'

                }
            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.loadSourcesInUse()

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/provider/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.provider = response.data
                    thisIns.editObject = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const templatesPromise = this.$http.get('/api/management/v1/template/?type=0')
                templatesPromise.then(function(response) {
                    thisIns.inputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const channelsPromise = this.$http.get('/api/management/v1/channel/')
                channelsPromise.then(function(response) {
                    thisIns.channels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const loadLocationsPromise = this.$http.get('/api/management/v1/location/')
                loadLocationsPromise.then(function(response) {
                    thisIns.locations = [{ id: 0, name: 'Any' }].concat(response.data)
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, templatesPromise, channelsPromise, loadLocationsPromise]).then(function() {
                    thisIns.dataLoaded = true
                }).finally(function() {
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            loadSourcesInUse() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/source/?inUse=true')
                loadPromise.then(function(response) {
                    thisIns.sourcesInUse = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            saveProvider() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.put('/api/management/v1/provider/' + this.$route.params.id, {
                    name: this.editObject.name,
                    max_connections: Number(this.editObject.max_connections),
                    allowed_connections: Number(this.editObject.allowed_connections),
                    playlist_url: this.editObject.playlist_url
                })

                addPromise.then(function() {
                    thisIns.editingDisabled = true
                    thisIns.$printSuccess('Provider saved')
                    thisIns.loadData()
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            removeProvider() {
                this.$vs.loading({
                    container: '#dataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.delete('/api/management/v1/provider/' + this.$route.params.id)
                loadPromise.then(function() {
                    thisIns.$printSuccess('Provider removed')
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/providers/')
                    })
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#dataDiv > .con-vs-loading')
                })
            },
            addSource() {
                this.$vs.loading({
                    container: '#addSourceDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const params = []

                for (let i = 0; i < this.enabledParameters.length; i++) {
                    if (this.parameterValues.hasOwnProperty(this.enabledParameters[i])) {
                        params.push({
                            key: this.enabledParameters[i],
                            value: this.parameterValues[this.enabledParameters[i]]
                        })
                    }
                }

                const selectedTemplate = {
                    id: Number(this.addObject.in_template),
                    params: params
                }

                const addPromise = this.$http.post('/api/management/v1/source/', {
                    provider_id: Number(this.$route.params.id),
                    channel_id: Number(this.addObject.channel_id),
                    location_id: Number(this.addObject.location_id),
                    in_template: selectedTemplate,
                    url: this.addObject.url,
                    checker_enabled: this.addObject.checker_enabled
                })

                addPromise.then(function() {
                    thisIns.$refs.sourcesTable.reloadSources()
                    thisIns.addSourcePrompt = false
                    thisIns.$printSuccess('Source added')
                    thisIns.addObject.url = ''
                    thisIns.$vs.loading.close('#addSourceDiv > .con-vs-loading')
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#addSourceDiv > .con-vs-loading')
                })
            },
            loadChannelData() {
                this.loadDataToObject('channels', this.channelRange, 'channelData', '#channelCard')
            },
            loadSourceData() {
                this.loadDataToObject('sources', this.sourceRange, 'sourceData', '#sourceCard')
            },
            loadConnectionsData() {
                this.loadDataToObject('connections', this.connectionsRange, 'connectionsData', '#connectionsCard')
            },
            loadDataToObject(metric, time, objectName, loaderElement) {
                this.$vs.loading({
                    container: loaderElement,
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/provider/' + this.$route.params.id + '/metrics/' + metric + '/' + time)
                loadPromise.then(function(response) {
                    thisIns[objectName] = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close(loaderElement + ' > .con-vs-loading')
                })
            },
            getMetricsChartOptions(title, colors) {
                return {
                    colors: colors,
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        tickAmount: 5,
                        min: 0
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            }
        },
        computed: {
            templateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.inputTemplates.length; i++) {
                    templatesMap[this.inputTemplates[i].id] = this.inputTemplates[i]
                }

                return templatesMap
            },
            channelMap() {
                const channelMap = {}
                for (let i = 0; i < this.channels.length; i++) {
                    channelMap[this.channels[i].id] = this.channels[i]
                }

                return channelMap
            }
        },
        watch: {
            channelRange() {
                this.loadChannelData()
            },
            sourceRange() {
                this.loadSourceData()
            }
        },
        mounted() {
            this.loadData()

            this.channelChartOptions = this.getMetricsChartOptions('Channels', ['#7367F0', '#28C76F', '#EA5455'])
            this.sourceChartOptions = this.getMetricsChartOptions('Sources', ['#7367F0', '#28C76F', '#EA5455'])
            this.connectionsChartOptions = this.getMetricsChartOptions('Connections', ['#7367F0', '#28C76F', '#EA5455'])

            this.loadChannelData()
            this.loadSourceData()
            this.loadConnectionsData()
        },
        beforeRouteLeave(to, from, next) {
            if (this.addSourcePrompt) {
                this.addSourcePrompt = false
                next(false)
            } else {
                next()
            }
        }
    }

</script>
<style lang="scss">
    #avatar-col {
        width: 10rem;
    }

    .simple-table {
        td {
            vertical-align: top;
            min-width: 170px;
            padding-bottom: .8rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }

</style>
